module.exports = __webpack_public_path__ + "static/media/sriracha-teen-hero-mobile.5a5f5685.jpg";